import React, { FC } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';

interface Props {
  title: string;
  subtitle?: string;
  meta?: string;
  badge?: string;
  onPress: () => void;
}

const Card = styled.TouchableOpacity`
  background-color: ${Colors.WHITE};
  border-width: 1px;
  border-color: ${Colors.CARD_BORDER};
  border-radius: 12px;
  padding: 14px 16px;
  margin: 6px 8px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.View`
  flex: 1;
  padding-right: 12px;
`;

const TitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

const Title = styled(Fonts.Bold)`
  font-size: 17px;
  color: ${Colors.TEXT};
`;

const Badge = styled.View`
  background-color: ${Colors.SURFACE};
  border-radius: 6px;
  padding: 2px 8px;
  margin-left: 8px;
`;

const BadgeText = styled(Fonts.Normal)`
  font-size: 12px;
  color: ${Colors.MAIN_COLOR};
`;

const Subtitle = styled(Fonts.Normal)`
  font-size: 13px;
  color: ${Colors.MUTED_TEXT};
  margin-top: 4px;
  line-height: 18px;
`;

const Meta = styled(Fonts.Normal)`
  font-size: 12px;
  color: ${Colors.MAIN_COLOR};
  margin-top: 6px;
`;

const Chevron = styled(Fonts.Bold)`
  font-size: 22px;
  color: ${Colors.SILVER_CHALICE};
  padding-left: 4px;
`;

const SelectCard: FC<Props> = ({ title, subtitle, meta, badge, onPress }) => (
  <Card onPress={onPress} accessibilityRole="button">
    <Left>
      <TitleRow>
        <Title>{title}</Title>
        {badge ? (
          <Badge>
            <BadgeText>{badge}</BadgeText>
          </Badge>
        ) : null}
      </TitleRow>
      {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      {meta ? <Meta>{meta}</Meta> : null}
    </Left>
    <Chevron>›</Chevron>
  </Card>
);

export default SelectCard;
